module.exports = __webpack_public_path__ + "img/flag-IT.5acb5768.svg";